"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
function concatPercent(value) {
    return value !== 0 ? value + "%" : value.toString();
}
function isOuterKnob(knobSize, trackHeight) {
    return knobSize > trackHeight;
}
function innerKnobWidth(knobSize, trackHeight, initialKnobWidth) {
    if (typeof initialKnobWidth !== 'undefined') {
        return 100 - initialKnobWidth - (trackHeight - knobSize) / 4;
    }
    return (trackHeight - knobSize) / 4;
}
function outerKnobWidth(initialKnobWidth) {
    return 100 - initialKnobWidth;
}
function calcUncheckedLeftValue(knobSize, trackHeight, knobWidth, alignment) {
    var result;
    if (alignment === 'right') {
        result = isOuterKnob(knobSize, trackHeight)
            ? outerKnobWidth(knobWidth)
            : innerKnobWidth(knobSize, trackHeight, knobWidth);
    }
    else {
        result = isOuterKnob(knobSize, trackHeight)
            ? 0
            : innerKnobWidth(knobSize, trackHeight);
    }
    return result;
}
function calcCheckedLeftValue(knobSize, trackHeight, knobWidth, alignment) {
    var result;
    if (alignment === 'right') {
        result = isOuterKnob(knobSize, trackHeight)
            ? 0
            : innerKnobWidth(knobSize, trackHeight);
    }
    else {
        result = isOuterKnob(knobSize, trackHeight)
            ? outerKnobWidth(knobWidth)
            : innerKnobWidth(knobSize, trackHeight, knobWidth);
    }
    return result;
}
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps;
    var checked = compData.checked, value = compData.value;
    var isDisabled = compProps.isDisabled;
    return {
        isDisabled: isDisabled,
        checked: checked,
        value: value,
    };
});
exports.css = withCompInfo_1.withCompInfo(['compProps'], function (_a) {
    var compProps = _a.compProps;
    var displayKnobIcons = compProps.displayKnobIcons, trackHeight = compProps.trackHeight, knobSize = compProps.knobSize, alignment = compProps.alignment;
    var knobWidth = knobSize / 2;
    return {
        '--toggleIconDisplay': displayKnobIcons ? 'block' : 'none',
        '--innerLabelHeight': concatPercent(knobSize),
        '--innerLabelWidth': concatPercent(knobWidth),
        '--outerLabelHeight': concatPercent(trackHeight),
        '--labelMovementRangeChecked': concatPercent(calcCheckedLeftValue(knobSize, trackHeight, knobWidth, alignment)),
        '--labelMovementRangeUnchecked': concatPercent(calcUncheckedLeftValue(knobSize, trackHeight, knobWidth, alignment)),
    };
});
//# sourceMappingURL=ToggleSwitch.js.map